import { render, staticRenderFns } from "./Diabetes.vue?vue&type=template&id=698efb89&scoped=true&"
import script from "./Diabetes.vue?vue&type=script&lang=js&"
export * from "./Diabetes.vue?vue&type=script&lang=js&"
import style0 from "./Diabetes.vue?vue&type=style&index=0&id=698efb89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698efb89",
  null
  
)

export default component.exports